<template>
    <div class=" uk-padding uk-background-muted" style="min-height: 100vh !important;">

        <h1  class="uk-heading-line uk-text-center specHeading" ><span>Featured Stories</span> </h1>

        <div class="uk-container uk-container-large">

            <div class="uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l uk-child-width-1-5@xl"  uk-grid>
                <div class="uk-padding-small " v-for="item in getFeatures">
                    <div class="uk-card ">
                        <div class="uk-card-media-top">
                          <img :src="item.acf.story_cover_image" alt="" style="width: 100%; border-radius: 15px">
                        </div>
                        <div class="uk-card-body uk-padding-small uk-padding-remove-left">

                          <h4 class="   specHeading" style="color: black !important;">{{item.title.rendered}}</h4>
                            <p class="uk-text-small " style="color: #666666;" v-html="item.content.rendered.substring(0, 110)"></p>
                            <button :id="item.slug"
                                    v-on:click="findFeature"
                                    class="uk-align-right uk-button uk-button-default uk-button-small "
                                    style="background-color: transparent; border: 1px solid silver; color: #666"

                            >

                                Read More ..</button>

                        </div>
                    </div>
                </div>
            </div>






        </div>
    </div>
</template>

<script>

    export default {
        name: "allfeaturestories",
        data(){
            return {
                feature: [],
            }
        },
        methods: {
            findFeature: function(event){
                //this.$store.commit('getArticle', (event.target.id))
                this.$router.push({ path: '/featurestory', query: { article: event.target.id }})
            }
        },
        computed: {
            getFeatures: function () {
                // `this` points to the vm instance
                return this.$store.state.featureStoriesAll
            }

        },
        beforeCreate(){
            this.$store.dispatch('getAllFeatures')
        }
    }
</script>

<style scoped>
    #headers{
        font-family: "Alegreya SC";

    }
</style>
